"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdkToApi = exports.addShortUrlRequestData = exports.stringifyOptions = exports.formatParamsForHttp = void 0;
exports.normToIdList = normToIdList;
exports.normToIdListIfExists = normToIdListIfExists;
exports.stringifyClipListOptions = stringifyClipListOptions;
exports.isPopulatedArray = isPopulatedArray;
exports.anyPopulatedArrays = anyPopulatedArrays;
exports.allPopulatedArrays = allPopulatedArrays;
exports.idsOfMadeTags = idsOfMadeTags;
exports.onlyInFormerTags = onlyInFormerTags;
exports.labelsOfUnmadeTags = labelsOfUnmadeTags;
const server_sdk_1 = require("@air/server-sdk");
const querystring_1 = require("querystring");
const clips_1 = require("./clips");
const request_1 = require("./request");
function normToIdList(arr) {
    return arr.map((item) => (typeof item === 'object' ? item.id : item));
}
function normToIdListIfExists(arr) {
    return arr && normToIdList(arr);
}
/**
 *
 * Converts an array into a comma-delimited string. Otherwise, returns the item
 * as-is
 */
function convertArrayParam(item) {
    return Array.isArray(item) ? normToIdList(item).join(',') : item;
}
/**
 *
 * Convert every value in an object to a version that can be processed by
 * `stringify`
 */
const normalizeParams = (obj = {}) => Object.entries(obj).reduce((acc, [key, value]) => typeof value !== 'undefined'
    ? Object.assign(Object.assign({}, acc), { [key]: convertArrayParam(value) }) : acc, {});
/**
 *
 * Normalizes all values in the passed-in object and then converts the object
 * into a string as well
 */
const formatParamsForHttp = (params = {}) => (0, querystring_1.stringify)(normalizeParams(params));
exports.formatParamsForHttp = formatParamsForHttp;
const stringifyOptions = (options) => (0, querystring_1.stringify)(Object.assign({}, normalizeParams(Object.assign({}, options))));
exports.stringifyOptions = stringifyOptions;
function stringifyClipListOptions(options = {}) {
    return (0, querystring_1.stringify)(Object.assign(Object.assign({}, clips_1.Clips.CLIP_LIST_DEFAULTS), normalizeParams(options)));
}
/**
 * The following three array functions are also present in db and utils
 * The tests for them are in Utils
 */
function isPopulatedArray(arr) {
    return !!arr && Array.isArray(arr) && !!arr.length;
}
/**
 * Given one or more arrays, determines if at least one of them is populated
 * Note: Must pass arrays as separate args, does not directly take an array of arrays
 */
function anyPopulatedArrays(...arrs) {
    return !!arrs && isPopulatedArray(arrs) && !!arrs.find(isPopulatedArray);
}
/**
 * Given one or more arrays, determines if all of them are populated
 * Note: Must pass arrays as separate args, does not directly take an array of arrays
 */
function allPopulatedArrays(...arrs) {
    return (!!arrs &&
        isPopulatedArray(arrs) &&
        arrs.findIndex((arr) => !isPopulatedArray(arr)) === -1);
}
function safeArray(arr) {
    return arr || [];
}
// If it has an ID then it is an already made tag
// Otherwise, we need to try to create the tag
function isTag(tag) {
    return !!tag.id;
}
function idsOfMadeTags(tags) {
    return safeArray(tags).reduce((ids, tag) => (isTag(tag) ? [...ids, tag.id] : ids), []);
}
function onlyInFormerTags(former, latter) {
    const latterSet = new Set(idsOfMadeTags(latter));
    return idsOfMadeTags(former).filter((id) => !latterSet.has(id));
}
function labelsOfUnmadeTags(tags) {
    return safeArray(tags).reduce((labels, tag) => isTag(tag) ? labels : [...labels, tag.label], []);
}
// short id is provided for public endpoint.
const addShortUrlRequestData = (requestData, shortId, options) => (Object.assign(Object.assign(Object.assign({}, requestData), (options || {})), { endpoint: `shorturl/${shortId}/${requestData.endpoint || ''}`, shortUrlProtection: { id: shortId } }));
exports.addShortUrlRequestData = addShortUrlRequestData;
const sdkToApi = (sdk) => Object.entries(sdk).reduce((res, [key, node]) => {
    if ((0, server_sdk_1.isEndpoint)(node)) {
        // TODO: method, path
        res[key] = ((args) => __awaiter(void 0, void 0, void 0, function* () {
            const { workspaceId } = args;
            return (0, request_1.airRequest)(node, {
                body: args,
                workspaceId,
                returnErrors: true,
            });
        }));
    }
    else {
        res[key] = (0, exports.sdkToApi)(node);
    }
    return res;
}, {});
exports.sdkToApi = sdkToApi;
//# sourceMappingURL=util.js.map